import { render, staticRenderFns } from "./otodetxgflzx.vue?vue&type=template&id=15ac5a72&scoped=true&"
import script from "./otodetxgflzx.vue?vue&type=script&lang=js&"
export * from "./otodetxgflzx.vue?vue&type=script&lang=js&"
import style0 from "./otodetxgflzx.vue?vue&type=style&index=0&id=15ac5a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac5a72",
  null
  
)

export default component.exports